<uni-error [errorObj]="error"> </uni-error>
